// Module
var code = `<section class="assignment-type-help-wrapper" role="alert" aria-live><p translate="activity-editor-new_activity-type-cannot-change"></p></section>`;
// Exports
export default code;